export default __webpack_public_path__ + "static/media/AElement Fusion.b2954bf1.jpg";